import { Component } from '@angular/core';

@Component({
  selector: 'ze-generic-fail',
  standalone: false,
  templateUrl: './generic-fail.component.html',
  styleUrl: './generic-fail.component.css',
})
export class GenericFailComponent {}
